export default "__VITE_ASSET__7c90bb56__"